import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Collapse,
  FormControl,
  FormControlLabel,
  // FormLabel,
  Radio,
  RadioGroup,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  // TablePagination,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import { ChangeEvent, Fragment, useContext, useMemo, useState } from "react";
import { ClaimContext, ClaimContextType } from "..";
import DetailsComponent from "./DetailsComponent";
import FilterButton from "./FilterButton";
import CustomTableBody from "../../../utilis/component/CustomTableBody";
import { useMutation } from "react-query";
import { CheckCircle } from "@mui/icons-material";
import { downloadClaims, submitClaims } from "../../services";
import usePopup from "../../../hooks/usePopup";
import moment from "moment";
import { SubmitResponseType } from "../types";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { TreeView } from "@mui/x-tree-view/TreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { useFetchPatientDetailsByEMR } from "../../../PatientCare/hooks/apiHooks";
// import useAuthentication from "@hooks/useAuthentication";

function ClaimList() {
  const theme = useTheme();
  const { showSnackbar, CustomModal } = usePopup();
  const [selected, setSelected] = useState(-1);
  const [checkedItems, setCheckedItems] = useState<any>({});
  const [showResult, setShowResult] = useState(false);
  const [errorList, setErrorList] = useState<SubmitResponseType[]>([]);
  const [open, setOpen] = useState(false);
  const { tableData, filter, setRefetch } = useContext(
    ClaimContext,
  ) as ClaimContextType;
  const [claimDownloadType, setClaimDownloadType] = useState<boolean>(true);
  const [openDownloadModal, setOpenDownloadModal] = useState<boolean>(false);
  const {
    mutate: getPatientByEmr,
    data: patientData,
    isLoading: patientDataLoading,
  } = useFetchPatientDetailsByEMR({});

  // const { user } = useAuthentication();
  //  const regionValue= user?.region;
  //    const idHeading =
  //   regionValue === "QATAR_REGION"
  //     ? "Qatar ID"
  //     : "Emirates Id";
  const idHeading = "Civil ID";
  const headings = [
    "checkbox",
    idHeading,
    // "Status",
    "Name",
    // "Post Office",
    "Encounter date",
    "MRN",
    "Doctor",
    "Insurance Type",
    "Insurance Name",
    // "Claim Id",
  ];

  const { mutate: submit, isLoading: submitLoading } = useMutation(
    submitClaims,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          const responseData = result?.response;
          open && setOpen(false);
          if (responseData) {
            setErrorList(responseData);
            setShowResult(true);
          } else {
            showSnackbar({
              message: "Error",
              variant: "warning",
              duration: 2000,
              open: true,
            });
          }
        } else {
          showSnackbar({
            message: result.responseMessage,
            variant: "warning",
            duration: 2000,
            open: true,
          });
        }
      },
    },
  );

  const { mutate: downloadClaim, isLoading: downloadLoading } = useMutation(
    downloadClaims,
    {
      onSuccess: (result) => {
        if (result.responseIndicator == "success") {
          if (result?.response) {
            try {
              try {
                const binaryData = atob(result.response.body);
                const byteNumbers = new Uint8Array(binaryData.length);
                for (let i = 0; i < binaryData.length; i++) {
                  byteNumbers[i] = binaryData.charCodeAt(i);
                }
                const blob = new Blob([byteNumbers], {
                  type: `application/${result?.response?.fileType?.toLowerCase() || "txt"}`,
                });
                const blobURL = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = blobURL;
                link.download = `Claim_download_${moment().format("DD-MM-YYYY hh:mm:ss A")}.${result.response.fileType || "txt"}`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(blobURL);
                showSnackbar({
                  message: "Downloaded successfully!",
                  variant: "success",
                  duration: 2000,
                  open: true,
                });
              } catch (error) {
                console.error("Error decoding or downloading file:", error);
                showSnackbar({
                  message: "Download failed!",
                  variant: "error",
                  duration: 2000,
                  open: true,
                });
              }
            } catch (error) {
              showSnackbar({
                message: "Failed to download file !",
                variant: "warning",
                duration: 2000,
                open: true,
              });
            }
          } else {
            showSnackbar({
              message: "Error",
              variant: "warning",
              duration: 2000,
              open: true,
            });
          }
        } else {
          showSnackbar({
            message: result.responseMessage,
            variant: "warning",
            duration: 2000,
            open: true,
          });
        }
      },
    },
  );

  const handleOpen = (e: any) => {
    const emrno: string = e.currentTarget.getAttribute("data-mrn") || "";
    const index = parseInt(e.currentTarget.getAttribute("data-index") || "-1");
    const encounterId = parseInt(e.currentTarget.getAttribute("data-encounterid") || "-1");
    console.log(index);
    getPatientByEmr({
      emrNo: emrno,
      encounterId: encounterId,
    });
    if (index == selected) {
      setSelected(-1);
    } else {
      setSelected(index);
    }
  };

  const handleSelectAll = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      let allItems = {};
      console.log(tableData);
      tableData.forEach((item: any, index: number) => {
        allItems = {
          ...allItems,
          [index]: parseInt(item.encounterId),
        };
      });
      setCheckedItems(allItems);
    } else {
      setCheckedItems({});
    }
  };

  const handleSelectOne = (key: number, encounterId: string) => {
    let item = { ...checkedItems };
    if (item[key]) {
      delete item[key];
    } else {
      item = {
        ...item,
        [key]: parseInt(encounterId),
      };
    }
    setCheckedItems(item);
  };

  const selectedItemsLength = useMemo(() => {
    return Object.keys(checkedItems).length;
  }, [checkedItems]);

  const submitSelectedClaims = () => {
    let claims: { encounterId: number }[] = [];
    for (let key in checkedItems) {
      claims = [...claims, { encounterId: checkedItems[key] }];
    }
    let type: "Submission" | "Resubmission" | "" = "";
    if (filter.flag == 1) {
      type = "Submission";
    }
    if (filter.flag == 3) {
      type = "Resubmission";
    }
    submit({
      isProduction: true,
      claims,
      type,
      postOfficeId: filter.postOfficeId,
    });
  };

  const handleSubmitClaims = () => {
    if (filter.all && Object.entries(checkedItems).length > 1) {
      console.clear();
      console.log(
        "Multiple claim id my present , Do you want to submit these claims ?",
      );
      setOpen(true);
    } else {
      submitSelectedClaims();
    }
  };

  const handleDownloadClaim = () => {
    let claims: { encounterId: number }[] = [];
    for (let key in checkedItems) {
      claims = [...claims, { encounterId: checkedItems[key] }];
    }
    const type = filter.flag === 3 ? "RESUBMISSION" : "SUBMISSION";
    downloadClaim({
      claims,
      type: type,
      isProduction: claimDownloadType,
      postOfficeId: filter.postOfficeId,
    });
  };

  const handleClose = () => {
    setShowResult(false);
    setRefetch(true);
  };

  return (
    <TableContainer className="flex flex-col h-fit">
      <CustomModal title="Claim submission !" open={open} setOpen={setOpen}>
        <div>
          <div className="p-3 w-[35vw] h-[50dvh] max-h-[12dvh] overflow-y-auto">
            <Typography fontSize={"1rem"} fontWeight={600}>
              Multiple Payer Id may present , Do you want to submit these claims
              ?
            </Typography>
          </div>
          <div className="p-2 flex justify-end gap-2">
            <Button
              color="error"
              onClick={() => {
                setOpen(false);
              }}
            >
              no
            </Button>
            <Button
              color="success"
              disabled={submitLoading}
              endIcon={
                submitLoading && <CircularProgress size={18} color="inherit" />
              }
              onClick={submitSelectedClaims}
            >
              yes
            </Button>
          </div>
        </div>
      </CustomModal>
      <CustomModal
        title="Submission response"
        open={showResult}
        setOpen={setRefetch}
        handleClose={handleClose}
      >
        <div className="p-3 w-[50vw] h-[50dvh] max-h-[50dvh] overflow-y-auto">
          <TreeView
            aria-label="file system navigator"
            // defaultCollapseIcon={<ExpandMoreIcon />}
            // defaultExpandIcon={<ChevronRightIcon />}
            sx={{ overflowX: "hidden" }}
          >
            {errorList.map((item, index) => (
              <TreeItem
                key={`${index}outter`}
                nodeId={`${index}outter`}
                label={
                  <div className="flex items-center gap-3">
                    {item.Success ? (
                      <CheckCircleIcon
                        sx={{
                          color: theme.palette.success.main,
                          fontSize: "16px",
                        }}
                      />
                    ) : (
                      <ErrorOutlineIcon
                        sx={{
                          color: theme.palette.error.main,
                          fontSize: "16px",
                        }}
                      />
                    )}
                    {item.UserMessage}
                  </div>
                }
              >
                {item.Error.map((e, i) => (
                  <TreeItem
                    key={`${index + i}TreeItem`}
                    sx={{ color: theme.palette.error.main, marginY: 1 }}
                    nodeId={`${i}item`}
                    label={
                      <div>
                        <FiberManualRecordIcon sx={{ fontSize: "8px" }} />{" "}
                        {e.ErrorText}
                      </div>
                    }
                  />
                ))}
              </TreeItem>
            ))}
          </TreeView>
        </div>
      </CustomModal>
      <CustomModal
        title="Claim Download"
        open={openDownloadModal}
        setOpen={setOpenDownloadModal}
      >
        <div className="p-3 w-[30vw] flex flex-col gap-2">
          <Typography>Download {selectedItemsLength} claims</Typography>
          <div className="flex gap-2 items-center justify-between">
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group"
                row
                defaultValue={true}
              >
                <FormControlLabel
                  sx={{ fontSize: "10px" }}
                  value={false}
                  control={
                    <Radio
                      // value={claimDownloadType}
                      size="small"
                      onChange={() => {
                        setClaimDownloadType(false);
                      }}
                    />
                  }
                  label="Test"
                />
                <FormControlLabel
                  sx={{ fontSize: "8px" }}
                  value={true}
                  control={
                    <Radio
                      // value={claimDownloadType}
                      size="small"
                      onChange={() => {
                        setClaimDownloadType(true);
                      }}
                    />
                  }
                  label="Production"
                />
              </RadioGroup>
            </FormControl>
            <Button
              disabled={downloadLoading}
              endIcon={
                downloadLoading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <ArrowDownwardIcon />
                )
              }
              onClick={handleDownloadClaim}
            >
              download
            </Button>
          </div>
        </div>
      </CustomModal>
      <div className="flex justify-between p-2 items-center border-b w-full">
        <Typography>Claim Submission</Typography>
        <div className="flex items-center gap-2">
          {selectedItemsLength > 0 && filter.flag != 2 && (
            <Button
              color="success"
              disabled={submitLoading}
              endIcon={
                submitLoading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <CheckCircle />
                )
              }
              onClick={handleSubmitClaims}
            >
              Submit selected
            </Button>
          )}
          {selectedItemsLength > 0 && (
            <Button
              color="primary"
              endIcon={<ArrowDownwardIcon />}
              onClick={() => {
                setOpenDownloadModal(true);
              }}
            >
              Claim download
            </Button>
          )}
          <FilterButton />
        </div>
      </div>
      <div className="max-h-[56dvh] h-[56dvh] overflow-y-auto">
        <Table
          size="small"
          aria-label="a dense table"
          className={tableData?.length ? "w-full" : "h-full"}
        >
          <TableHead
            className="sticky top-0"
            sx={{
              backgroundColor: theme.palette.background.paper,
              opacity: 1,
              zIndex: 10,
            }}
          >
            <TableRow>
              {headings?.map((title, index) => (
                <TableCell
                  key={`${index}tablecell`}
                  sx={{ fontWeight: "bold" }}
                >
                  {title == "checkbox" ? (
                    <Checkbox
                      // disabled={!Boolean(filter.insuranceType)}
                      checked={
                        selectedItemsLength == tableData?.length &&
                        tableData?.length > 0
                      }
                      sx={{ padding: "0px" }}
                      color="default"
                      onChange={handleSelectAll}
                    />
                  ) : (
                    title
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <CustomTableBody
            alert={"No records"}
            dataLoading={false}
            isData={tableData?.length > 0}
            totalSpan={{ col: headings.length, row: filter.pageSize }}
          >
            {tableData?.map((item: any, index: number) => (
              <Fragment key={`${index}tablekey`}>
                <TableRow
                  hover
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    backgroundColor:
                      index % 2 == 0 ? theme.palette.grey[100] : "",
                  }}
                >
                  <TableCell>
                    <Checkbox
                      // disabled={!Boolean(filter.insuranceType)}
                      sx={{ padding: "0px" }}
                      onClick={() => {
                        handleSelectOne(index, item.encounterId);
                      }}
                      checked={checkedItems[index] ? true : false}
                    />
                  </TableCell>
                  <TableCell
                    className="cursor-pointer"
                    data-mrn={item.mrn}
                    data-index={index}
                    data-encounterid={item.encounterId}
                    onClick={handleOpen}
                  >
                    {item.emiratesId}
                  </TableCell>
                  <TableCell
                    className="cursor-pointer"
                    data-mrn={item.mrn}
                    data-index={index}
                    data-encounterid={item.encounterId}
                    onClick={handleOpen}
                  >
                    {item.patientName ? item.patientName : "----"}
                  </TableCell>
                  <TableCell
                    className="cursor-pointer"
                    data-mrn={item.mrn}
                    data-index={index}
                    data-encounterid={item.encounterId}
                    onClick={handleOpen}
                  >
                    {item.encounterDate
                      ? moment(item.encounterDate).format("DD-MM-YYYY hh:mm A")
                      : "----"}
                  </TableCell>
                  <TableCell
                    className="cursor-pointer"
                    data-mrn={item.mrn}
                    data-index={index}
                    data-encounterid={item.encounterId}
                    onClick={handleOpen}
                  >
                    {item.mrn ? item.mrn : "----"}
                  </TableCell>
                  <TableCell
                    className="cursor-pointer"
                    data-mrn={item.mrn}
                    data-index={index}
                    data-encounterid={item.encounterId}
                    onClick={handleOpen}
                  >
                    {item.doctorName ? item.doctorName : "----"}
                  </TableCell>
                  <TableCell
                    className="cursor-pointer"
                    data-mrn={item.mrn}
                    data-index={index}
                    data-encounterid={item.encounterId}
                    onClick={handleOpen}
                  >
                    {item.insuranceType ? item.insuranceType : "----"}
                  </TableCell>
                  <TableCell
                    className="cursor-pointer"
                    data-mrn={item.mrn}
                    data-index={index}
                    data-encounterid={item.encounterId}
                    onClick={handleOpen}
                  >
                    {item.payer}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    style={{
                      paddingBottom: 0,
                      paddingTop: 0,
                      backgroundColor:
                        index % 2 == 0 ? theme.palette.grey[100] : "",
                    }}
                    colSpan={headings.length + 1}
                  >
                    <Collapse
                      in={index == selected}
                      timeout="auto"
                      unmountOnExit
                    >
                      <Box sx={{ margin: 1 }}>
                        {patientDataLoading ? (
                          <div className="flex justify-center w-full gap-3">
                            {" "}
                            Loading <CircularProgress size={15} />{" "}
                          </div>
                        ) : (
                          <DetailsComponent
                            data={patientData?.response || null}
                          />
                        )}
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </Fragment>
            ))}
          </CustomTableBody>
        </Table>
      </div>
      <div className="flex justify-end w-full">
        {/* <TablePagination
          sx={{ border: 0, backgroundColor: theme.palette.background.paper }}
          rowsPerPageOptions={[5, 10, 25]}
          colSpan={3}
          count={tableData?.length || 0}
          rowsPerPage={filter.pageSize}
          page={filter.pageNo}
          slotProps={{
            select: {
              inputProps: {
                "aria-label": "rows per page",
              },
              native: true,
            },
          }}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        /> */}
      </div>
    </TableContainer>
  );
}

export default ClaimList;
